<script setup lang="ts">
import type { Designer, ProductLine } from '~/types/api'

const props = defineProps<{
  designer: Designer
  line: ProductLine
}>()

const { getResourceUrl } = useResources()
const route = useRoute()
</script>

<template>
  <div
    class="container flex w-full flex-col items-center bg-white pt-20 lg:flex-row"
  >
    <div class="w-full py-20 lg:w-1/2">
      <TypographyH1 class="mb-8">
        <span v-html="props.designer?.title"></span>
      </TypographyH1>
      <TypographyBase class="mb-8 line-clamp-4 w-full lg:w-8/12">
        {{ stripHtml(props.designer?.description) }}
      </TypographyBase>
      <!-- TODO: correct #hash in button link  -->
      <NuxtLink
        :to="
          $localePath({
            name: 'designer-slug',
            params: { slug: props.designer?.urlSlug },
          })
        "
      >
        <UiButtonBlackOutline>
          {{ $t('productline.designer.cta') }}
        </UiButtonBlackOutline>
      </NuxtLink>
    </div>
    <div
      class="order-first h-full w-full overflow-hidden lg:order-none lg:w-1/2"
    >
      <img
        :src="
          getResourceUrl(props.designer?.thumbnailImage?.url + '/1280x1280/FIT')
        "
        :alt="props.designer?.title"
        class="mt-20 h-full w-full object-cover lg:mt-0"
      />
    </div>
  </div>
</template>
